/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// look at this
//https://www.lightgalleryjs.com/blog/7-best-react-image-gallery-libraries/

// full page image gallery
//https://www.lightgalleryjs.com/demos/react-image-gallery/

//GalleryImagesFullScreen2

//GalleryImagesReactGridGallery
//import GalleryImagesReactGridGallery from './GalleryImagesReactGridGallery';

//https://www.npmjs.com/package/react-image-gallery

// import stylesheet if you're not already using CSS @import
// how do i create a css file for react-image-gallery

//ran this thru claudes code refactoring tool
// suggest improvements for this component
// give me the entire code to copy


// redesign this component to look more elegant and polished and add accents
// use tailwind css in the className directive 
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."

// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task




// i want to show eventDetails?.selectedGalleryImages in a div below MultiSelectDropdown
// give me the relevant code and instructions
                  

//claude code

// wrap <div className={`gallery-images__grid in div with a white backgound
// and makesure that nothing gets messed up
// give me the relevant code and instructions



import React, { useState, useEffect, useMemo, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { MdTableBar } from "react-icons/md";
import { GiCheckMark } from "react-icons/gi";

import { get_event_details, update_event_details_selectedGalleryImages,  
    messageClear } from '../store/reducers/eventDetailsReducer';

//import GalleryImagesFullScreen1 from './GalleryImagesFullScreen1';

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./GalleryImagesCustomStyles.css";

import MultiSelectDropdown from '../components/MultiSelectDropdown';
import DividerAccent from '../components/DividerAccent';
import GetSellerConfig from '../components/GetSellerConfig';

import toast from 'react-hot-toast';

/* ─────────────────────────────────────────────
   Component-scoped styles
   All selectors are prefixed with .gallery-images__
   so they never bleed into other pages.
───────────────────────────────────────────── */
const styles = `
  /* ── Section wrapper ── */
  .gallery-images__section {
    min-height: 60vh;
  }

  /* ── Page title (large heading) ── */
  .gallery-images__title {
    letter-spacing: -0.02em;
    line-height: 1.15;
  }

  /* ── Subtitle / subheading ── */
  .gallery-images__subtitle {
    letter-spacing: 0.3em;
    text-transform: uppercase;
    font-weight: 600;
  }

  /* ── Outer grid container ──
     IMPORTANT: NO overflow:hidden here — that was clipping the right nav arrow.
     Box-shadow and border-radius still apply fine without it. ── */
  .gallery-images__grid {
    border-radius: 0.75rem;
    overflow: visible;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
    transition: box-shadow 0.3s ease;
  }
  .gallery-images__grid:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);
  }

  /* ── Sidebar panel (select + saved) ── */
  .gallery-images__sidebar-card {
    border-radius: 1rem;
    background: #ffffff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .gallery-images__sidebar-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.10);
  }

  /* ── Selected items list ── */
  .gallery-images__selected-list {
    scrollbar-width: thin;
    scrollbar-color: currentColor transparent;
  }
  .gallery-images__selected-list::-webkit-scrollbar {
    width: 4px;
  }
  .gallery-images__selected-list::-webkit-scrollbar-track {
    background: transparent;
  }
  .gallery-images__selected-list::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: currentColor;
    opacity: 0.4;
  }

  /* ── List item row ── */
  .gallery-images__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 2px 4px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
    transition: background 0.15s ease;
  }
  .gallery-images__list-item:last-child {
    border-bottom: none;
  }
  .gallery-images__list-item:hover {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 4px;
  }

  /* ── Save button ── */
  .gallery-images__save-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: none;
    cursor: pointer;
    letter-spacing: 0.03em;
    transition: filter 0.2s ease, transform 0.15s ease;
  }
  .gallery-images__save-btn:hover {
    filter: brightness(1.10);
    transform: translateY(-1px);
  }
  .gallery-images__save-btn:active {
    transform: translateY(0);
    filter: brightness(0.95);
  }

  /* ── Saved-settings image card ── */
  .gallery-images__saved-card {
    border-radius: 0.5rem;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .gallery-images__saved-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  }
  .gallery-images__saved-card img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    display: block;
    transition: transform 0.35s ease;
  }
  .gallery-images__saved-card:hover img {
    transform: scale(1.04);
  }

  /* ── Carousel column ──
     Always takes full width of its grid cell.
     Padding-right reserves space so the right nav arrow
     is never pushed outside the visible area. ── */
  .gallery-images__carousel-col {
    width: 100%;
    min-width: 0;          /* prevent grid blowout */
    box-sizing: border-box;
  }

  /* ── Image gallery wrapper ──
     overflow:visible is essential — the nav arrows are absolutely
     positioned and must not be clipped by the container. ── */
  .gallery-images__carousel-wrap {
    position: relative;
    width: 100%;
    overflow: visible;
  }

  /* ── Force the image-gallery root to never overflow its column ── */
  .gallery-images__carousel-wrap .image-gallery {
    width: 100%;
    box-sizing: border-box;
  }

  /* ── Slide images: fill width, constrain height, no clipping issues ── */
  .gallery-images__carousel-wrap .image-gallery-slide img {
    width: 100%;
    object-fit: cover;
    max-height: 520px;
    display: block;
  }

  /* ── Nav arrows: always visible, pinned inside the container ── */
  .gallery-images__carousel-wrap .image-gallery-left-nav,
  .gallery-images__carousel-wrap .image-gallery-right-nav {
    z-index: 10;
    /* Use padding instead of negative translate so arrows stay in-bounds */
    padding: 50px 6px;
  }
  .gallery-images__carousel-wrap .image-gallery-left-nav {
    left: 0;
  }
  .gallery-images__carousel-wrap .image-gallery-right-nav {
    right: 0;
  }
  /* Scale arrow SVG down on narrow screens so it always fits */
  @media (max-width: 480px) {
    .gallery-images__carousel-wrap .image-gallery-left-nav .image-gallery-svg,
    .gallery-images__carousel-wrap .image-gallery-right-nav .image-gallery-svg {
      height: 48px;
      width: 24px;
    }
  }

  /* ── Thumbnails ── */
  .gallery-images__carousel-wrap .image-gallery-thumbnails-wrapper {
    padding: 6px 0 2px;
  }
  .gallery-images__carousel-wrap .image-gallery-thumbnail {
    border-radius: 4px;
    overflow: hidden;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  .gallery-images__carousel-wrap .image-gallery-thumbnail:hover {
    opacity: 0.85;
    transform: scale(1.04);
  }
  .gallery-images__carousel-wrap .image-gallery-thumbnail.active {
    border-color: currentColor;
    transform: scale(1.06);
  }

  /* ── Bullets ── */
  .gallery-images__carousel-wrap .image-gallery-bullet {
    transition: transform 0.2s ease;
  }
  .gallery-images__carousel-wrap .image-gallery-bullet.active {
    transform: scale(1.35);
  }

  /* ── Description ── */
  .gallery-images__carousel-wrap .image-gallery-description {
    font-size: 13px;
    letter-spacing: 0.05em;
    padding: 6px 12px;
  }

  /* ── Fade-in animation for the whole section ── */
  @keyframes galleryFadeUp {
    from { opacity: 0; transform: translateY(18px); }
    to   { opacity: 1; transform: translateY(0);    }
  }
  .gallery-images__section {
    animation: galleryFadeUp 0.55s ease both;
  }

  /* ── Responsive tweaks ── */
  @media (max-width: 768px) {
    .gallery-images__grid {
      border-radius: 0.5rem;
    }
    .gallery-images__sidebar-card {
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
`;

const GalleryImages = () => {
    //const { seller } = useSelector(state => state.seller)
    const { userInfo } = useSelector(state => state.auth)    
    const { allSiteGalleryImages } = useSelector(state => state.home)
    const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);

    const allSiteGalleryImagesNew = useMemo(() => {
        //console.log(allSiteGalleryImages)
        if (!allSiteGalleryImages?.length) return [];
        return allSiteGalleryImages.map(({ _id, caption, image }) => ({
            id: _id,
            name: caption,
            image: image
        }));
    }, [allSiteGalleryImages]);
    //console.log(allSiteGalleryImagesNew)
    // console.log('allSiteGalleryImages raw:', allSiteGalleryImages);
    // console.log('allSiteGalleryImagesNew mapped:', allSiteGalleryImagesNew);
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();
    
    // const sellerId = seller?._id 
    // const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
    // const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1

    // const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
    // const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    // const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    // const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
    const [selectedItems, setSelectedItems] = useState([]);
    const dispatch = useDispatch()
    
    useEffect(() => {
        if(userInfo && userInfo.id){
            dispatch(get_event_details(userInfo.id))    
        }
    },[userInfo.id])
        
    useEffect(() => {
        if (eventDetails) {
            setSelectedItems(JSON.parse(eventDetails?.selectedGalleryImages))
        }
    },[eventDetails])    
        
    const [state, setState] = useState({
        selectedGalleryImages: '[]'
    })
    
    const [imagesReactImageGallery, setImagesReactImageGallery] = useState([])
    useEffect(() => {
        const imagesTemp = allSiteGalleryImages.map(imageName => ({
            original: imageName.image,
            thumbnail: imageName.image,
            description: imageName.caption
        }));
        setImagesReactImageGallery(imagesTemp)
    }, [allSiteGalleryImages])

    const update_event_details_selectedGalleryImages_local = () => {
         dispatch(update_event_details_selectedGalleryImages({
            customerId: userInfo.id,
            selectedGalleryImages: JSON.stringify(selectedItems)
        }))
    }

    const imagesReactImageGalleryStatic = [
        {
            original: "https://picsum.photos/id/1018/1000/600/",
            thumbnail: "https://picsum.photos/id/1018/250/150/",
        },
        {
            original: "https://picsum.photos/id/1015/1000/600/",
            thumbnail: "https://picsum.photos/id/1015/250/150/",
        },
        {
            original: "https://picsum.photos/id/1019/1000/600/",
            thumbnail: "https://picsum.photos/id/1019/250/150/",
        },
    ];

    useEffect(() => { 
        if (successMessage) {
            toast.success(successMessage)
            dispatch(messageClear())  
        } 
        if (errorMessage) {
            toast.error(errorMessage)
            dispatch(messageClear())  
        } 
    },[successMessage, errorMessage])

    return (
        <div>
            {/* ── Inject scoped styles ── */}
            <style>{styles}</style>

            <Header />
            <section
                className="gallery-images__section w-full py-6 border-none border-black"
                style={{ backgroundColor: sellerComponentBackgroundColor }}>

                <div className='hidden 2xs:text-xs xs:text-sm sm:text-md md:text-md mg-lg:text-xl 
                    lg:text-xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl 4xl:text-2xl 4k:text-2xl
                    font-bold text-center m-1 pl-16 pr-16' 
                    style={{color:sellerPrimaryColor1}}>
                    Some Of Our Artistic Presentations And Set-Ups To Welcome Your Guests To Your Simcha/Party
                </div>

                <div
                    className={`gallery-images__title 2xs:text-xs xs:text-sm sm:text-md md:text-md mg-lg:text-xl 
                    lg:text-2xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl 4xl:text-2xl 4k:text-2xl
                    font-medium text-center 
                    leading-tight mb-2 sm:mb-1.5 xs:mb-1.5`}
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark, letterSpacing: '-0.01em', }}>
                    Our Artistic Presentations &amp; Table Set-Ups
                </div>
                <div
                    className="gallery-images__subtitle text-center text-[16px] sm:text-[12px] xs:text-[12px]
                    mb-2 sm:mb-1.5 xs:mb-1.5"
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                    To Welcome Your Guests To Your Simcha / Party
                </div>

                <div className='mb-3 w-full text-center items-center justify-center justify-items-center' >
                    <DividerAccent />
                </div>

                <div className={` grid grid-cols-1 items-center justify-center justify-items-center`} >
                    
                    <div className={` w-1/12 `} />
                    <div className="w-[83%]" style={{ backgroundColor: '#ffffff', padding: '0px', borderRadius: '0.75rem' }}>
                        <div className={`gallery-images__grid grid 2xs:grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 md-lg:grid-cols-1 
                            lg:grid-cols-[1fr_3fr] xl:grid-cols-[1fr_3fr] 2xl:grid-cols-[1fr_3fr] 3xl:grid-cols-[1fr_3fr] 
                            4xl:grid-cols-[1fr_3fr] 4k:grid-cols-[1fr_3fr]
                            w-full border p-2 rounded-xl `} 
                            style={{
                                borderColor:sellerPrimaryColor1, 
                                color:sellerPrimaryColor1, 
                                backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight,
                            }}>

                            {/* ── Sidebar (order-2 on mobile so gallery shows first) ── */}
                            <div className={` ${userInfo ? '2xs:order-2 xs:order-2 sm:order-2 md:order-2 md-lg:order-2 ' : 'hidden'} `}>
                                <div className='gallery-images__sidebar-card w-[240px] ml-2 mr-2 mt-0.5 p-3 border bg-white rounded-2xl'
                                    style={{ 
                                        borderTop: `6px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                        borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
                                        borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                        borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                    }}>
                                
                                    {allSiteGalleryImagesNew?.length > 0 && (
                                        <MultiSelectDropdown id="multiSelectedGalleryImages" items={allSiteGalleryImagesNew}
                                            initialSelectedItems={selectedItems} onSelectionChange={setSelectedItems}
                                            title="Select Table Settings"
                                        />
                                    )}
                                    <div className="gallery-images__selected-list p-2 bg-gray-50 border border-gray-200 rounded-md h-[180px] overflow-y-auto" 
                                        style={{color:sellerPrimaryColor1 + sellerColorSuffixDark,
                                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark,
                                        }}>
                                        <div className="text-[14px] font-semibold mb-0">
                                            Selected Table Settings:
                                        </div>  
                                        {selectedItems.length > 0 ? (
                                            <ul className="space-y-1">
                                                {selectedItems.map((item) => (
                                                    <li key={item.id} className="gallery-images__list-item"
                                                        style={{borderColor:sellerPrimaryColor1}}>
                                                        <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
                                                            {item.name}
                                                        </span>
                                                        <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
                                                    </li>
                                                ))}
                                            </ul>
                                            ) : (
                                            <p className="italic font-normal text-[13px]">No Table Settings Selected.</p>
                                        )}
                                    </div>
                                    <button onClick={update_event_details_selectedGalleryImages_local}
                                        className="gallery-images__save-btn mt-1 w-full px-1 py-1.5 text-white font-semibold text-md rounded-md" 
                                        style={{
                                            backgroundColor:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                        }}>
                                        <MdTableBar className="w-6 h-6 inline-block" /> Save Table Settings
                                    </button>
                                </div>
                                <div>
                                    <div className='gallery-images__sidebar-card w-[240px] ml-2 mr-2 mt-1.5 p-3 border bg-white rounded-2xl'
                                        style={{ 
                                            borderTop: `6px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                            borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
                                            borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                            borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                        }}>
                                        <div className='border-none border-black overflow-y-auto max-h-[400px]'>
                                            <div className="text-[14px] font-semibold mb-2" style={{ color: sellerPrimaryColor1 }}>
                                                Saved Table Settings:
                                            </div>
                                            {(() => {
                                                const savedGalleryImages = eventDetails?.selectedGalleryImages
                                                    ? JSON.parse(eventDetails.selectedGalleryImages)
                                                    : [];
                                                return savedGalleryImages.length > 0 ? (
                                                    <div className="flex flex-col gap-3">
                                                        {savedGalleryImages.map((item) => (
                                                            <div key={item.id}
                                                                className="gallery-images__saved-card flex flex-col items-center border"
                                                                style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixLight }}>
                                                                <img src={item.image} alt={item.name} />
                                                                <div className="w-full px-2 py-1 text-center text-[13px] font-medium"
                                                                    style={{ 
                                                                        color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
                                                                    }}>
                                                                    {item.name}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="italic font-normal text-[13px]" style={{ color: sellerPrimaryColor1 }}>
                                                        No saved settings found.
                                                    </p>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* ── Carousel column ──
                                w-full + min-w-0 lets the grid cell shrink properly
                                without ever pushing the right arrow off-screen. ── */}
                            <div className={`gallery-images__carousel-col ${userInfo ? 
                                'mt-0.5 2xs:order-1 xs:order-1 sm:order-1 md:order-1 md-lg:order-1' 
                                : ''} border`}
                                style={{
                                    borderColor:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                    color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                    backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight,
                                }}>

                                <div className="gallery-images__carousel-wrap">
                                    <ImageGallery items={imagesReactImageGallery} showThumbnails={true} lazyLoad={true}
                                        showPlayButton={false} showFullscreenButton={false} showBullets={true} 
                                        showNav={true} thumbnailPosition="bottom" description={false}  />
                                </div>
                                {
                                    //thumbnailClass='' originalClass='h-[100px] w-full object-cover object-center'
                                    //originalClass - custom image class
                                    //thumbnailClass - custom thumbnail class
                                    //sizes="60vw"
                                }
                            </div>
                        </div>
                    </div>
                    <div className={` w-1/12 `} />
                </div>
                {
                // <div className='hidden items-center justify-center justify-items-center'>
                //     <div className="w-1/12" />
                //     <div className="w-10/12 border" 
                //         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
                //         <div className={` border p-2 m-1 overflow-auto h-[356px]`}>
                //             <GalleryImagesFullScreen1 />
                //         </div>
                //     </div>
                //     <div className="w-1/12" />
                // </div>
                }
            </section>
            <Footer />
        </div>
    );
};

export default GalleryImages;



//my original code
// import React, { useState, useEffect, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import { MdTableBar } from "react-icons/md";
// import { GiCheckMark } from "react-icons/gi";

// import { get_event_details, update_event_details_selectedGalleryImages,  
//     messageClear } from '../store/reducers/eventDetailsReducer';

// //import GalleryImagesFullScreen1 from './GalleryImagesFullScreen1';

// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";
// import "./GalleryImagesCustomStyles.css";

// import MultiSelectDropdown from '../components/MultiSelectDropdown';
// import DividerAccent from '../components/DividerAccent';

// import toast from 'react-hot-toast';

// const GalleryImages = () => {
//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)    
//     const { allSiteGalleryImages } = useSelector(state => state.home)
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     //selectedGalleryImages
//     //console.log('eventDetails ', eventDetails?.selectedGalleryImages)

//     const allSiteGalleryImagesNew = allSiteGalleryImages?.map(({ _id, caption, image }) => ({
//         id: _id,           // Keep existing key
//         name: caption,    // Create new key with different name   // Assign old value to new key
//         image: image      // Keep existing key
//     }));
//     //console.log('allSiteGalleryImages ', allSiteGalleryImages)
    
//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
//     const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
//     const [selectedItems, setSelectedItems] = useState([]);

//     const dispatch = useDispatch()
    
//     useEffect(() => {
//         if(userInfo && userInfo.id){
//             dispatch(get_event_details(userInfo.id))    
//         }
//     },[userInfo.id])
        
//     useEffect(() => {
//         if (eventDetails) {
//             setSelectedItems(JSON.parse(eventDetails?.selectedGalleryImages))
//             //console.log('selectedItems set ', selectedItems)
//             //console.log('eventDetails?.selectedGalleryImages ', eventDetails?.selectedGalleryImages)
//         }
//     },[eventDetails])    
        
//     const [state, setState] = useState({
//         selectedGalleryImages: '[]'
//     })
//     //console.log(state)
    
//     //ReactImageGallery
//     const [imagesReactImageGallery, setImagesReactImageGallery] = useState([])
//     useEffect(() => {
//         const imagesTemp = allSiteGalleryImages.map(imageName => ({
//             original: imageName.image,
//             thumbnail: imageName.image,
//             description: imageName.caption
//         }));
//         //console.log('images2\n', images2)
//         setImagesReactImageGallery(imagesTemp)
//     }, [allSiteGalleryImages])

//     //console.log('images3\n', images3)
//     const update_event_details_selectedGalleryImages_local = () => {
//          //console.log(pro)
//          //state.selectedGalleryImages = JSON.stringify(selectedItems)
//          dispatch(update_event_details_selectedGalleryImages({
//             customerId: userInfo.id,
//             selectedGalleryImages:  JSON.stringify(selectedItems) //state.selectedGalleryImages
//         }))
//     }

//     const imagesReactImageGalleryStatic = [
//         {
//             original: "https://picsum.photos/id/1018/1000/600/",
//             thumbnail: "https://picsum.photos/id/1018/250/150/",
//         },
//         {
//             original: "https://picsum.photos/id/1015/1000/600/",
//             thumbnail: "https://picsum.photos/id/1015/250/150/",
//         },
//         {
//             original: "https://picsum.photos/id/1019/1000/600/",
//             thumbnail: "https://picsum.photos/id/1019/250/150/",
//         },
//     ];
//     //console.log('images\n', images)
//     useEffect(() => { 
//         if (successMessage) {
//             //console.log(successMessage)
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div>
//             <Header />
//             <section
//                 className="w-full py-6 border-none border-black"
//                 style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium }}>

//                 <div className='hidden 2xs:text-xs xs:text-sm sm:text-md md:text-md mg-lg:text-xl 
//                     lg:text-xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl 4xl:text-2xl 4k:text-2xl
//                     font-bold text-center m-1 pl-16 pr-16' 
//                     style={{color:sellerPrimaryColor1}}>
//                     Some Of Our Artistic Presentations And Set-Ups To Welcome Your Guests To Your Simcha/Party
//                 </div>

//                 <div
//                     className={`2xs:text-xs xs:text-sm sm:text-md md:text-md mg-lg:text-xl 
//                     lg:text-2xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl 4xl:text-2xl 4k:text-2xl
//                     font-medium text-center 
//                     leading-tight mb-2 sm:mb-1.5 xs:mb-1.5`}
//                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark, letterSpacing: '-0.01em', }}>
//                     Our Artistic Presentations & Table Set-Ups
//                 </div>
//                 <div
//                     className="text-center text-[16px] sm:text-[12px] xs:text-[12px] tracking-[0.3em] 
//                     uppercase font-semibold mb-2 sm:mb-1.5 xs:mb-1.5"
//                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                     To Welcome Your Guests To Your Simcha / Party
//                 </div>

//                 <div className='mb-3 w-full text-center items-center justify-center justify-items-center' >
//                     <DividerAccent />
//                 </div>

//                 <div className={`grid grid-cols-1 items-center justify-center justify-items-center`} >
//                     <div className={` w-1/12 `} />
//                     <div className={`grid 2xs:grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 md-lg:grid-cols-1 
//                         lg:grid-cols-[1fr_3fr] xl:grid-cols-[1fr_3fr] 2xl:grid-cols-[1fr_3fr] 3xl:grid-cols-[1fr_3fr] 
//                         4xl:grid-cols-[1fr_3fr] 4k:grid-cols-[1fr_3fr]
//                         w-[83%] border p-2 rounded-xl `} 
//                         style={{
//                             borderColor:sellerPrimaryColor1, 
//                             color:sellerPrimaryColor1, 
//                             backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight
//                         }}>
//                         <div className={` ${userInfo ? '2xs:order-2 xs:order-2 sm:order-2 md:order-2 md-lg:order-2 ' : 'hidden'} `}>
//                             <div className=' w-[240px] ml-2 mr-2 mt-0.5 p-3 border bg-white rounded-2xl'
//                                 style={{ 
//                                     borderTop: `6px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                     borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
//                                     borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                     borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                 }}>
//                                 <MultiSelectDropdown id="multiSelectedGalleryImages" items={allSiteGalleryImagesNew} initialSelectedItems={selectedItems} 
//                                     onSelectionChange={setSelectedItems} title="Select Table Settings" />
//                                 <div className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[180px] overflow-y-auto" 
//                                     style={{color:sellerPrimaryColor1 + sellerColorSuffixDark,
//                                         borderColor:sellerPrimaryColor1 + sellerColorSuffixDark,
//                                     }}>
//                                     <div className="text-[14px] font-semibold mb-0">
//                                         Selected Table Settings:
//                                     </div>  
//                                     {selectedItems.length > 0 ? (
//                                         <ul className=" space-y-1">
//                                             {selectedItems.map((item) => (
//                                                 <li key={item.id} className="flex items-center justify-between w-full 
//                                                     px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                     <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                         {item.name}
//                                                     </span>
//                                                     <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                         ) : (
//                                         <p className="italic font-normal text-[13px]">No Table Settings Selected.</p>
//                                     )}
//                                 </div>
//                                 <button  onClick={update_event_details_selectedGalleryImages_local}
//                                     className="mt-1 w-full px-1 py-1.5 text-white font-semibold text-md rounded-md" 
//                                     style={{
//                                         backgroundColor:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                     }}>
//                                     <MdTableBar className="w-6 h-6 inline-block" /> Save Table Settings
//                                 </button>
//                             </div>
//                             <div>
//                                 <div className='w-[240px] ml-2 mr-2 mt-1.5 p-3 border bg-white rounded-2xl'
//                                     style={{ 
//                                         borderTop: `6px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                         borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
//                                         borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                         borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                     }}>
//                                     <div className='border-none border-black overflow-y-auto max-h-[400px]'>
//                                         <div className="text-[14px] font-semibold mb-2" style={{ color: sellerPrimaryColor1 }}>
//                                             Saved Table Settings:
//                                         </div>
//                                         {(() => {
//                                             const savedGalleryImages = eventDetails?.selectedGalleryImages
//                                                 ? JSON.parse(eventDetails.selectedGalleryImages)
//                                                 : [];
//                                             return savedGalleryImages.length > 0 ? (
//                                                 <div className="flex flex-col gap-3 ">
//                                                     {savedGalleryImages.map((item) => (
//                                                         <div key={item.id} className="flex flex-col items-center border rounded-lg overflow-hidden"
//                                                             style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixLight }}>
//                                                             <img
//                                                                 src={item.image}
//                                                                 alt={item.name}
//                                                                 className="w-full h-[140px] object-cover"
//                                                             />
//                                                             <div className="w-full px-2 py-1 text-center text-[13px] font-medium"
//                                                                 style={{ 
//                                                                     color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight 
//                                                                 }}>
//                                                                 {item.name}
//                                                             </div>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             ) : (
//                                                 <p className="italic font-normal text-[13px]" style={{ color: sellerPrimaryColor1 }}>
//                                                     No saved settings found.
//                                                 </p>
//                                             );
//                                         })()}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
                        
//                         <div className={` ${userInfo ? 
//                             'w-[65%] mt-0.5 border-none 2xs:order-1 2xs:w-full xs:order-1 xs:w-full sm:order-1 sm:w-full md:order-1 md:w-full md-lg:order-1 md-lg:w-full' 
//                             : 'w-[90%] '}  border `}
//                             style={{
//                                 borderColor:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                 color:sellerPrimaryColor1 + sellerColorSuffixDark, 
//                                 backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight,
//                             }}>

//                             <ImageGallery items={imagesReactImageGallery} showThumbnails={true} lazyLoad={true}
//                                 showPlayButton={false} showFullscreenButton={false} showBullets={true} 
//                                 showNav={true} thumbnailPosition="bottom" description={false}  />
//                             {
//                                 //thumbnailClass='' originalClass='h-[100px] w-full object-cover object-center'
//                                 //originalClass - custom image class
//                                 //thumbnailClass - custom thumbnail class
//                                 //sizes="60vw"
//                             }
//                         </div>
//                     </div>
//                     <div className={` w-1/12 `} />
//                 </div>
//                 {
//                 // <div className='hidden items-center justify-center justify-items-center'>
//                 //     <div className="w-1/12" />
//                 //     <div className="w-10/12 border" 
//                 //         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                 //         <div className={` border p-2 m-1 overflow-auto h-[356px]`}>
//                 //             <GalleryImagesFullScreen1 />
//                 //         </div>
//                 //     </div>
//                 //     <div className="w-1/12" />
//                 // </div>
//                 }
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default GalleryImages;




//refacorted
// import React, { useState, useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import { MdTableBar } from 'react-icons/md';
// import { GiCheckMark } from 'react-icons/gi';

// import {
//     get_event_details,
//     update_event_details_selectedGalleryImages,
//     messageClear,
// } from '../store/reducers/eventDetailsReducer';

// import ImageGallery from 'react-image-gallery';
// import 'react-image-gallery/styles/css/image-gallery.css';
// import './GalleryImagesCustomStyles.css';
// import MultiSelectDropdown from '../components/MultiSelectDropdown';

// import toast from 'react-hot-toast';

// const GalleryImages = () => {
//     const { seller } = useSelector((state) => state.seller);
//     const { userInfo } = useSelector((state) => state.auth);
//     const { allSiteGalleryImages } = useSelector((state) => state.home);
//     const { eventDetails, errorMessage, successMessage } = useSelector(
//         (state) => state.eventDetails
//     );

//     const dispatch = useDispatch();

//     // Derived seller values
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;
//     const sellerProductPluralTerm = seller?.productPluralTerm

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
//     const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
//     // Normalize gallery images for the MultiSelectDropdown
//     const allSiteGalleryImagesNew = useMemo(
//         () =>
//             allSiteGalleryImages?.map(({ _id, caption, image }) => ({
//                 id: _id,
//                 name: caption,
//                 image,
//             })) ?? [],
//         [allSiteGalleryImages]
//     );

//     // Normalize gallery images for react-image-gallery
//     const imagesReactImageGallery = useMemo(
//         () =>
//             allSiteGalleryImages?.map(({ image, caption }) => ({
//                 original: image,
//                 thumbnail: image,
//                 description: caption,
//             })) ?? [],
//         [allSiteGalleryImages]
//     );

//     const [selectedItems, setSelectedItems] = useState([]);

//     // Fetch event details on mount
//     useEffect(() => {
//         if (userInfo?.id) {
//             dispatch(get_event_details(userInfo.id));
//         }
//     }, [userInfo?.id, dispatch]);

//     // Sync selected gallery images from fetched event details
//     useEffect(() => {
//         if (eventDetails?.selectedGalleryImages) {
//             try {
//                 setSelectedItems(JSON.parse(eventDetails.selectedGalleryImages));
//             } catch {
//                 setSelectedItems([]);
//             }
//         }
//     }, [eventDetails]);

//     // Toast notifications
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     const handleSaveTableSettings = () => {
//         dispatch(
//             update_event_details_selectedGalleryImages({
//                 customerId: userInfo.id,
//                 selectedGalleryImages: JSON.stringify(selectedItems),
//             })
//         );
//     };

//     const isLoggedIn = Boolean(userInfo?.id);

//     // const responsiveTextSize =
//     //     '2xs:text-xs xs:text-sm sm:text-md md:text-md md-lg:text-2xl lg:text-2xl xl:text-3xl 2xl:text-4xl';

//     const galleryGridCols =
//         'grid 2xs:grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 md-lg:grid-cols-2 ' +
//         'lg:grid-cols-[1fr_3fr] xl:grid-cols-[1fr_3fr] 2xl:grid-cols-[1fr_3fr]';

//     return (
//         <div>
//             <Header />
//             <section
//                 className="w-full py-6 border-none border-black"
//                 style={{ backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium }}>
//                     {/*  ${responsiveTextSize }  */}
//                     <div
//                         className={`font-medium text-center 
//                         leading-tight mb-2 sm:mb-1.5 xs:mb-1.5`}
//                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark, letterSpacing: '-0.01em', }}>
//                         Artistic Presentations & Set-Ups
//                     </div>
//                     <div
//                         className="text-[14px] text-center sm:text-[12px] xs:text-[12px] tracking-[0.3em] 
//                         uppercase font-semibold mb-2 sm:mb-1.5 xs:mb-1.5"
//                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                         To Welcome Your Guests To Your Simcha / Party
//                     </div>
        
//             <div className=" items-center justify-center justify-items-center">
//                 {/* Gallery images grid w-[83%] */}
//                 <div
//                     className={` ${galleryGridCols}   p-0 border rounded-2xl`}
//                     style={{
//                         borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                         color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                         backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium,
//                     }}>
//                     {/* Sidebar: table settings selector (logged-in users only) */}
                    
//                         <div className="2xs:order-2 xs:order-2 sm:order-2 md:order-2 md-lg:order-2">
//                             {isLoggedIn && (        
//                             <div className="w-[232px] m-2 border border-gray-700 p-2 bg-white rounded-2xl"
//                                 style={{ 
//                                     borderTop: `4px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                     borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
//                                     borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                     borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
//                                 }}>
//                                 <MultiSelectDropdown
//                                     id="multiSelectedGalleryImages"
//                                     items={allSiteGalleryImagesNew}
//                                     initialSelectedItems={selectedItems}
//                                     onSelectionChange={setSelectedItems}
//                                     title="Select Table Settings"
//                                 />
//                                 <div
//                                     className="p-2 bg-gray-50 border border-gray-200 rounded-md h-[180px] overflow-y-auto"
//                                     style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                     <p className="text-[14px] font-semibold mb-0">
//                                         Selected Table Settings:
//                                     </p>

//                                     {selectedItems.length > 0 ? (
//                                         <ul className="space-y-1">
//                                             {selectedItems.map((item) => (
//                                                 <li
//                                                     key={item.id}
//                                                     className="flex items-center justify-between w-full px-1 py-0 text-left">
//                                                     <span
//                                                         className="font-normal text-[14px]"
//                                                         style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                                                         {item.name}
//                                                     </span>
//                                                     <GiCheckMark className="w-5 h-5 text-green-500 inline-block" />
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     ) : (
//                                         <p className="italic font-normal text-[13px]">
//                                             No Table Settings Selected.
//                                         </p>
//                                     )}
//                                 </div>

//                                 <button
//                                     type="button"
//                                     onClick={handleSaveTableSettings}
//                                     className="mt-2 w-full px-1 py-2 text-white font-semibold text-md rounded-md"
//                                     style={{
//                                         backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                     }}>
//                                     <MdTableBar className="w-6 h-6 inline-block mr-1" />
//                                     Save Table Settings
//                                 </button>
//                             </div>
//                             )}

//                         </div>
                    

//                     {/* Main image gallery */}
//                     <div
//                         className={`border ${
//                             isLoggedIn
//                                 ? '2xs:order-1 2xs:w-full xs:w-full sm:w-full md:w-full md-lg:w-full w-[85%]'
//                                 : 'w-[70%]'
//                         }`}
//                         style={{
//                             borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                             color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                             backgroundColor: sellerSecondaryColor1 + sellerColorSuffixMedium,
//                         }}>
//                         <ImageGallery
//                             items={imagesReactImageGallery}
//                             showThumbnails
//                             lazyLoad
//                             showPlayButton={false}
//                             showFullscreenButton={false}
//                             showBullets
//                             showNav
//                             thumbnailPosition="bottom"
//                         />
//                     </div>
                    
//                 </div>
//             </div>
//             </section>
//             <Footer />
//         </div>
        
//     );
// };

// export default GalleryImages;












/*
<ImageGallery items={images3} showThumbnails={true} />;
            
https://www.npmjs.com/package/react-image-gallery
<ImageGallery items={images3} showThumbnails={true} />;
//npm install lightgallery

<Header />
import Header from '../components/Header';
import Footer from '../components/Footer';

<LightGallery></LightGallery>
               
<Footer />
cuinsie ntype thru out site

Cleveland Vaad Hakashrus


create react component for a gallery images, a page that shows all the imgaes, that loads as the user scrolls down, when the user clicks on an image it shows a large imge image 

npx create-react-app infinite-scroll-gallery
cd infinite-scroll-gallery
npm install -D tailwindcss
npx tailwindcss init

https://www.digitalocean.com/community/tutorials/how-to-build-an-infinite-scroll-image-gallery-with-react-css-grid-and-unsplash

https://blog.logrocket.com/react-infinite-scroll/#:~:text=The%20most%20common%20method%20to,json();%20if%20(res.

https://react-photo-album.com/

https://www.npmjs.com/package/react-infinite-scroller

https://www.npmjs.com/package/react-infinite-scroll-component

https://learnersbucket.com/examples/interview/create-a-lightbox-modal-image-gallery-in-reactjs/#:~:text=Creating%20the%20lightbox%20(modal%20image,%2Dhand_144627%2D51099.jpg?

GalleryImages.jsx

https://www.lightgalleryjs.com/demos/react-image-gallery/
https://www.lightgalleryjs.com/demos/react-carousel/
https://www.lightgalleryjs.com/demos/thumbnails/

import LightGallery from 'lightgallery/react';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

// If you want you can use SCSS instead of css
// import 'lightgallery/scss/lightgallery.scss';
// import 'lightgallery/scss/lg-zoom.scss';

// // import plugins if you need
// import lgThumbnail from 'lightgallery/plugins/thumbnail';
// import lgZoom from 'lightgallery/plugins/zoom';
import GalleryImagesReactGridGallery from './GalleryImagesReactGridGallery';


<LightGallery />


https://podcasts.apple.com/us/podcast/transferable-skills/id1754996232


*/